import { ReactComponent as PlusIcon } from "assets/icons/plus-icon.svg";
import { FoodIDModal } from "components";
import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { BranchIdsContainerProps, SnappFoodIDTypes } from "./BranchId.props";
import "./style.scss";

const BranchIdComponent = React.memo<BranchIdsContainerProps>(
    ({ item, handleChange, isVirtualBranch }) => {
        const [snappFoodIds, setSnappFoodIds] = useState<SnappFoodIDTypes[]>(
            []
        );
        const [showModal, setShowModal] = useState<boolean>(false);

        useEffect(() => {
            const tempSnappFoodIds: Array<SnappFoodIDTypes> = [];

            if (item?.snappfood_ids && snappFoodIds.length === 0) {
                item.snappfood_ids.forEach((snappfood_id) => {
                    tempSnappFoodIds.push({
                        ...snappfood_id,
                        key: uuidv4(),
                    });
                });

                setSnappFoodIds(tempSnappFoodIds);
            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [item]);

        const deActiveAllSnappFoodIds = () => {
            const deactivedSnappFoodIds = snappFoodIds.map((snappfood_id) => ({
                ...snappfood_id,
                is_active: false,
            }));

            return [...deactivedSnappFoodIds];
        };

        const handleAddID = (isVirtual: boolean, id: number) => {
            setShowModal(false);
            const deActivedSnappFoodIds = deActiveAllSnappFoodIds();
            deActivedSnappFoodIds.push({
                id: 0,
                snappfood_id: id,
                is_active: true,
                key: uuidv4(),
            });

            setSnappFoodIds(deActivedSnappFoodIds);

            handleChange?.(deActivedSnappFoodIds);
        };

        return (
            <Card className="mb-2 vendor-card">
                <Card.Body>
                    <div className="vendor">
                        <span className="vendor-title mb-2 d-block text-center">
                            {item?.title}
                        </span>
                        <>
                            {snappFoodIds &&
                                snappFoodIds.map((item, index) => (
                                    <Form.Control
                                        type="number"
                                        min="0"
                                        key={index}
                                        value={item.snappfood_id}
                                        className={`mb-1 d-block text-center border-0 ${
                                            item.is_active ? "active-id" : ""
                                        }`}
                                        disabled={true}
                                    />
                                ))}

                            {!isVirtualBranch && (
                                <>
                                    <div
                                        className="mt-3 text-center cursor-pointer d-inline-block"
                                        onClick={() => setShowModal(true)}
                                    >
                                        <PlusIcon className="ml-2" />
                                        <span className="new-item-btn">
                                            اضافه کردن شناسه
                                        </span>
                                    </div>
                                    <FoodIDModal
                                        show={showModal}
                                        virtual={isVirtualBranch}
                                        handleClose={() => setShowModal(false)}
                                        handleConfirm={handleAddID}
                                        isBranch={true}
                                    />
                                </>
                            )}
                        </>
                    </div>
                </Card.Body>
            </Card>
        );
    }
);

export default BranchIdComponent;
